import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@progress/kendo-react-common';
import './Navbar.css';

export const Navbar: React.FC = () => {
    const { user, isAuthenticated, isAdmin, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">
                    Research Assistant
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target=".navbar-collapse"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                    <ul className="navbar-nav flex-grow-1">
                    </ul>
                    <ul className="navbar-nav">
                        {isAuthenticated ? (
                            <>
                                {isAdmin && (
                                    <li className="nav-item">
                                        <Link className="nav-link text-dark" to="/register">
                                            <Icon name="users-solid" size="medium" themeColor="secondary" style={{ marginBottom: '2px' }} />
                                        </Link>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <span className="nav-link text-dark">
                                        Hi {user?.username || user?.email}!
                                    </span>
                                </li>
                                <li className="nav-item">
                                    <button className="nav-link btn btn-link text-dark" onClick={handleLogout}>
                                        Logout
                                    </button>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <Link className="nav-link text-dark" to="/login">
                                        Login
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

